import { render } from "./Interests.vue?vue&type=template&id=6842ccce&scoped=true&ts=true"
import script from "./Interests.vue?vue&type=script&lang=ts"
export * from "./Interests.vue?vue&type=script&lang=ts"

import "./Interests.vue?vue&type=style&index=0&id=6842ccce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6842ccce"]])

export default __exports__